import React from "react";
import { NavLink } from "react-router-dom";

const Header = () => {
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    window.location.href = "/";
  };

  const menuItems = [
    {
      label: "Dashboard",
      icon: "ri-dashboard-2-line",
      path: "/",
    },
    {
      label: "All Request",
      icon: "ri-message-2-line",
      path: "/AllRequests",
    },
    {
      label: "Project List",
      icon: "ri-profile-line",
      path: "/ProjectList",
    },
  ];

  return (
    <div>
      <header
        id="page-topbar"
        style={{
          backgroundColor: "black",
          borderBottom: "1px solid lightgray",
        }}
      >
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <NavLink to="/" className="logo logo-dark">
                  <span>
                    <img
                      src="/assets/images/new_logo_white.png"
                      alt=""
                      height={72}
                    />
                  </span>
                  <span className="logo-lg">
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}assets/abstart-logo.png`}
                      alt=""
                      height={80}
                    />
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}assets/talentco-new-logo.png`}
                      alt=""
                      height={100}
                    />
                  </span>
                </NavLink>

                <a href="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}assets/logo-color.jpeg`}
                      alt=""
                      height={22}
                    />
                  </span>
                  <span className="logo-lg">
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}assets/logo-color.jpeg`}
                      alt=""
                      height={17}
                    />
                  </span>
                </a>
              </div>

              <button
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span />
                  <span />
                  <span />
                </span>
              </button>
            </div>

            <div className="d-flex align-items-center">
              <div
                className="dropdown ms-sm-3 header-item topbar-user"
                style={{ backgroundColor: "black" }}
              >
                <button
                  type="button"
                  className="btn"
                  id="page-header-user-dropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="d-flex align-items-center">
                    <img
                      className="rounded-circle header-profile-user"
                      src="/assets/Image.jpg"
                      alt="Avatar"
                    />
                    <span className="text-start ms-xl-2">
                      <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                        Contractor
                      </span>
                      <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                        Contractor Login
                      </span>
                    </span>
                  </span>
                </button>

                <div className="dropdown-menu dropdown-menu-end">
                  <h6 className="dropdown-header">
                    Welcome Master Contractor!
                  </h6>
                  <div className="dropdown-divider" />
                  <NavLink
                    className="dropdown-item"
                    to={"/AccountInformation"}
                  >
                    <i className={`ri-user-fill text-muted fs-16 align-middle me-1`} />
                    <span className="align-middle">My Account</span>
                  </NavLink>
                  <NavLink className="dropdown-item" to="/" onClick={handleLogout}>
                    <i className="mdi mdi-logout text-muted fs-16 align-middle me-1" />
                    Logout
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div
        className="app-menu navbar-menu"
        style={{ backgroundColor: "#272b30" }}
      >
        <div className="navbar-brand-box">
          <a href="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src="/assets/images/logo-sm.png" alt="" height={22} />
            </span>
            <span className="logo-lg">
              <img
                src={`${process.env.REACT_APP_BASE_URL}assets/images/logo-dark.png`}
                alt=""
                height={17}
              />
            </span>
          </a>

          <a href="/" className="logo logo-light">
            <span className="logo-sm">
              <img
                src={`${process.env.REACT_APP_BASE_URL}assets/images/logo-sm.png`}
                alt=""
                height={22}
              />
            </span>
            <span className="logo-lg">
              <img
                src={`${process.env.REACT_APP_BASE_URL}assets/images/logo-light.png`}
                alt=""
                height={17}
              />
            </span>
          </a>

          <button
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line" />
          </button>
        </div>

        <div id="scrollbar">
          <div className="container-fluid">
            <ul className="navbar-nav">
              <li className="menu-title">
                <span>Menu</span>
              </li>

              {menuItems.map((item, index) => (
                <li className="nav-item" key={index}>
                  <NavLink className="nav-link" to={item.path}>
                    <i className={item.icon} />
                    <span>{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="sidebar-background" />
      </div>

      <div className="vertical-overlay" />
    </div>
  );
};

export default Header;
